export { default } from './BarMetrics';
